jQuery($ => {
  class Accordion {
    constructor(element) {
      this._        = element;
      this._element = $(element);
      this._button  = this._element.find('.m-accordion__toggle');
      this._panel   = this._element.find('.m-accordion__panel');

      this._group     = this._element.closest('.m-accordions');
      this._groupItem = this._element.closest('.m-accordions__item');

      this.init();
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Initialize
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    init() {
      this.setupHandlers();
      this._element.trigger( 'init', this );
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup Handlers
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    setupHandlers() {
      this._button.on('mousedown', this.handleButtonMousedown);
      this._button.on('keydown', this.handleButtonKeydown);
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Open
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleOpen = () => {
      this._element.addClass("m-accordion--open");
      this._button.attr("aria-expanded", "true");
      this._panel.slideDown(200);

      if (
        this._button.attr("aria-disabled") &&
        this._button.attr("aria-disabled") === "false"
      ) {
        this._button.attr("aria-disabled", "true");

        if (this._group[0]) {
          const $other_accordions = this._group.find(".m-accordion__toggle").not(this._button);

          $other_accordions.attr("aria-disabled", "false");

          $other_accordions.each(function() {
            $(this).closest('.m-accordion').accordion('handleClose');
          });
        }
      }

      this._element.trigger( 'open', this );
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Close
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleClose = () => {
      if (
        !this._button.attr("aria-disabled") ||
        this._button.attr("aria-disabled") === "false"
      ) {
        this._element.removeClass("m-accordion--open");
        this._button.attr("aria-expanded", "false");
        this._panel.slideUp(200);

        this._element.trigger( 'close', this );
      }
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Toggle
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleToggle = () => {
      if (this._panel.is(":visible")) {
        this.handleClose();
      } else {
        this.handleOpen();
      }
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Button Mousedown
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleButtonMousedown = () => {
      this.handleToggle();
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Button Keydown
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleButtonKeydown = event => {
      switch (event.key) {
        case "Enter":
        case "spacebar":
        case " ":
          event.preventDefault();
          this.handleToggle();
          break;

        case "ArrowUp":
          event.preventDefault();
          if (this._groupItem) {
            const $prevGroupItem = this._groupItem.prev();

            if ($prevGroupItem[0]) {
              $prevGroupItem.find(".m-accordion__toggle").focus();
            }
          }
          break;

        case "ArrowDown":
          event.preventDefault();
          if (this._groupItem) {
            const $nextGroupItem = this._groupItem.next();

            if ($nextGroupItem[0]) {
              $nextGroupItem.find(".m-accordion__toggle").focus();
            }
          }
          break;

        case "Home":
          event.preventDefault();
          if (this._groupItem) {
            this._groupItem
              .parent()
              .find(".m-accordions__item")
              .first()
              .find(".m-accordion__toggle")
              .focus();
          }
          break;

        case "End":
          event.preventDefault();
          if (this._groupItem) {
            this._groupItem
              .parent()
              .find(".m-accordions__item")
              .last()
              .find(".m-accordion__toggle")
              .focus();
          }
          break;
      }
    }
  }

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Setup jQuery Plugin
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $.fn.accordion = function() {
    var _ = this,
        opt = arguments[0],
        args = Array.prototype.slice.call(arguments, 1),
        l = _.length,
        i,
        ret;
    for (i = 0; i < l; i++) {
      if (typeof opt == 'object' || typeof opt == 'undefined')
        _[i].accordion = new Accordion(_[i], opt);
      else
        ret = _[i].accordion[opt].apply(_[i].accordion, args);
      if (typeof ret != 'undefined') return ret;
    }
    return _;
  }

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Run
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $('.m-accordion').accordion();
});